import { OrderFulfillmentContainerLocationDetailFragment } from '../../../../../graphql/fragments/orderFulfillmentContainerLocationDetail.generated';
import { ContainerTypeAmount } from '../../../../../graphql/generatedTypes';
import i18n from '@/utils/i18n';

const getContainersGroupedByType = (
  containers: OrderFulfillmentContainerLocationDetailFragment[],
  manualAmounts: ContainerTypeAmount[],
): Record<
  number,
  (OrderFulfillmentContainerLocationDetailFragment & {
    amount?: number;
    sealed?: boolean;
    isEditable?: boolean; // only for containerStation.manualAmounts
  })[]
> => {
  const containersByType = containers.reduce(
    (acc, container) => {
      if (!acc[container.container_type_id]) {
        acc[container.container_type_id] = [];
      }
      acc[container.container_type_id].push(container);
      return acc;
    },
    {} as Record<
      number,
      (OrderFulfillmentContainerLocationDetailFragment & { amount?: number })[]
    >,
  );

  for (const manualAmount of manualAmounts) {
    const manualAmountArray: (OrderFulfillmentContainerLocationDetailFragment & {
      amount?: number;
    })[] = [
      {
        container_id: 'manual_amount',
        container_type_id: manualAmount.container_type_id,
        container_name: i18n.t('OrderFulfillment:manualAmount'),
        container_type_name: manualAmount.container_type_name,
        container_type_image: manualAmount.container_type_image,
        amount: manualAmount.amount,
        sealed: false,
        isEditable: true,
      },
      {
        container_id: 'manual_amount_sealed',
        container_type_id: manualAmount.container_type_id,
        container_name: i18n.t('OrderFulfillment:manualAmountSealed'),
        container_type_name: manualAmount.container_type_name,
        container_type_image: manualAmount.container_type_image,
        amount: manualAmount.amount_sealed,
        sealed: true,
        isEditable: true,
      },
    ].filter((c) => c.amount > 0);

    containersByType[manualAmount.container_type_id] = manualAmountArray.concat(
      containersByType[manualAmount.container_type_id] || [],
    );
  }

  return containersByType;
};

export default getContainersGroupedByType;
